<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
    </div>

    <v-flex xs12>
      <v-row justify="center">
        <v-col md="8">
          <v-row>
            <v-col cols="12" v-if="providerPermissions['change-provider-tax-information']">
              <v-card flat tile>
                <v-card-title>
                  <v-row>
                    <v-col>
                      Configuración
                    </v-col>
                    <v-col class="d-flex justify-end">
                      <v-btn
                        rounded
                        small
                        depressed
                        color="primary"
                        :disabled="!form.isValid"
                        @click="submit">
                        Guardar datos del proveedor
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-form ref="form" v-model="form.isValid" lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        Datos fiscales
                      </v-col>
                      <v-col cols="12">
                        <span>
                          En caso de ser una persona moral, no poner el régimen societario (S.A. de C.V. ó SAPI de C.V. por ejemplo)
                        </span>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          :rules="rules.taxName"
                          label="Nombre fiscal"
                          @input="form.taxName = form.taxName.toUpperCase()"
                          @change="deleteAccents(form.taxName)"
                          v-model="form.taxName"/>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          :rules="rules.taxId"
                          label="RFC"
                          @input="form.taxId = form.taxId.toUpperCase()"
                          v-model="form.taxId"/>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          :rules="rules.zipCode"
                          label="Código postal"
                          maxlength="5"
                          v-model="form.address.zipCode"/>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="form.address.country"
                          label="País"
                          placeholder="MX"
                          :items="countrycodes"
                          :filter="searchCode"
                          item-text="name"
                          item-value="code"
                          dense
                          rounded
                          hide-details
                          outlined
                          :rules="rules.country"/>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          dense
                          rounded
                          outlined
                          hide-details
                          :items="taxRegimes"
                          item-text="name"
                          item-value="satId"
                          :rules="rules.fiscalRegime"
                          label="Regimen Fiscal"
                          v-model="form.fiscalRegime">
                          <template v-slot:item="{ item }">
                            {{ item.satId }} | {{ item.name }}
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-divider/>
                        <div class="my-3">
                          Certificado de sello digital
                        </div>
                        <div>
                          Necesitarás subir el <b>certificado</b> que es el archivo con terminación <b>".cer"</b> y la <b>llave privada</b> que es el archivo con terminación <b>".key"</b> de tu Certificado de Sello Digital.
                        </div>
                        <div>
                          Para más información <a href="https://www.sat.gob.mx/tramites/17507/envia-la-solicitud-para-tu-certificado-de-sello-digital-para-emitir-facturas-electronicas" target="_blank">haz click aquí</a>.
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <v-file-input
                          dense
                          rounded
                          outlined
                          hide-details
                          accept=".cer"
                          label="Certificado"
                          v-model="form.certificateFile"/>
                      </v-col>
                      <v-col cols="12">
                        <v-file-input
                          dense
                          rounded
                          outlined
                          hide-details
                          accept=".key"
                          label="Private key"
                          v-model="form.privateKeyFile"/>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          dense
                          rounded
                          outlined
                          hide-details
                          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showPassword ? 'text' : 'password'"
                          label="Password"
                          v-model="form.privateKeyPassword"
                          @click:append="showPassword = !showPassword"
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </v-layout>
</template>

<script>
import countrycodes from '@/lib/countrycodes'

export default {
  name: 'Providers',
  data () {
    return {
      countrycodes,
      section: 'Datos fiscales',
      overlay: false,
      disabled: true,
      form: {
        taxName: '',
        taxId: '',
        fiscalRegime: '',
        taxRegistrationNumber: '',
        address: {
          street: '',
          exteriorNumber: '',
          interiorNumber: '',
          neighborhood: '',
          zipCode: '',
          locality: '',
          municipality: '',
          state: '',
          country: 'MX'
        },
        csdId: '',
        taxRegime: '',
        email: '',
        wansoftId: '',
        certificate: '',
        privateKey: '',
        privateKeyPassword: '',
        certificateFile: null,
        privateKeyFile: null,
        isValid: false
      },
      taxRegimes: [
        { satId: '601', name: 'General de Ley Personas Morales' },
        { satId: '603', name: 'Personas Morales con Fines no Lucrativos' },
        { satId: '605', name: 'Sueldos y Salarios e Ingresos Asimilados a Salarios' },
        { satId: '606', name: 'Arrendamiento' },
        { satId: '607', name: 'Régimen de Enajenación o Adquisición de Bienes' },
        { satId: '608', name: 'Demás ingresos' },
        { satId: '609', name: 'Consolidación' },
        { satId: '610', name: 'Residentes en el Extranjero sin Establecimiento Permanente en México' },
        { satId: '611', name: 'Ingresos por Dividendos (socios y accionistas)' },
        { satId: '612', name: 'Personas Físicas con Actividades Empresariales y Profesionales' },
        { satId: '614', name: 'Ingresos por intereses' },
        { satId: '615', name: 'Régimen de los ingresos por obtención de premios' },
        { satId: '616', name: 'Sin obligaciones fiscales' },
        { satId: '620', name: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos' },
        { satId: '621', name: 'Incorporación Fiscal' },
        { satId: '622', name: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras Sí Sí' },
        { satId: '623', name: 'Opcional para Grupos de Sociedades' },
        { satId: '624', name: 'Coordinados' },
        { satId: '625', name: 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas' },
        { satId: '626', name: 'Régimen Simplificado de Confianza' },
        { satId: '628', name: 'Hidrocarburos' },
        { satId: '629', name: 'De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales' },
        { satId: '630', name: 'Enajenación de acciones en bolsa de valores' }
      ],
      rules: {
        email: [
          v => !!v || this.$t('validations.email.required'),
          v => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) || this.$t('validations.email.valid')
        ],
        street: [v => !!v || 'Street is required'],
        exteriorNumber: [v => !!v || 'Exterior number is required'],
        interiorNumber: [v => !!v || 'Interior number is required'],
        neighborhood: [v => !!v || 'Neighborhood is required'],
        zipCode: [
          v => !!v || 'Zipcode is required',
          v => v.length === 5 || 'Zipcode must be 5 digits',
          v => /^[a-zA-Z0-9 ]*$/g.test(v) || 'Only alphabetic characters and numbers are allowed'
        ],
        locality: [v => !!v || 'Locality is required'],
        municipality: [v => !!v || 'Municipality is required'],
        state: [v => !!v || 'State is required'],
        country: [v => !!v || 'Country is required'],
        wansoftId: [v => !!v || 'WansoftId is required'],
        certificate: [v => !!v || !this.uploadRequired || 'Certificate is requiered'],
        privateKey: [v => !!v || !this.uploadRequired || 'Privatekey is required'],
        privateKeyPassword: [v => !!v || !this.uploadRequired || 'Privatekey password is required'],
        taxName: [
          v => !!v || 'Tax name is required',
          v => /^[a-zA-Z0-9 ]*$/g.test(v) || 'Only alphabetic characters and numbers are allowed',
          v => {
            const forbiddenWords = ['SA', 'SAPI', 'CV', 'SRL', 'SNC', 'SCS', 'SCA', 'SAS']
            const regex = new RegExp(`^(?!.*\\b(${forbiddenWords.join('|')})\\b)[a-zA-Z0-9 ]+$`)
            return regex.test(v) || 'The tax name should not contail the fiscal regime'
          }
        ],
        taxId: [
          v => !!v || 'Tax Id is required',
          v => /^[a-zA-Z0-9]*$/g.test(v) || 'Only alphabetic characters and numbers are allowed'
        ],
        taxRegistrationNumber: [v => !!v || 'Tax registration number is required']
      },
      showPassword: false,
      uploadRequired: false
    }
  },
  computed: {
    provider () {
      return this.$store.state.currentProvider.data._id
    },
    providerPermissions () {
      return this.$store.state.login.permissions['settings'].components['tax-information'].actions
    }
  },
  async mounted () {
    await this.get()
    this.checkUploadRequired()
  },
  methods: {
    searchCode (item, queryText, itemText) {
      const name = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return name.indexOf(searchText) >= 0
    },
    async cancel () {
      await this.get()
      this.disabled = true
    },
    async submit () {
      if (this.$refs.form.validate()) {
        this.overlay = true
        try {
          const form = new FormData()
          form.append('csdId', this.form.csdId)
          form.append('taxName', this.form.taxName)
          form.append('taxId', this.form.taxId)
          form.append('address', JSON.stringify(this.form.address))
          form.append('fiscalRegime', this.form.fiscalRegime)
          form.append('certificate', this.form.certificateFile)
          form.append('privateKey', this.form.privateKeyFile)
          form.append('privateKeyPassword', this.form.privateKeyPassword)
          if (!this.form._id) {
            await this.$api.post(`/v1/providers/${this.provider}/settings`, form)
          } else {
            await this.$api.put(`/v1/providers/${this.provider}/settings`, form)
          }
          this.$toasted.show('Los datos se guardaron con éxito', { duration: 3000 })
          await this.cancel()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    async get () {
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/providers/${this.provider}/settings`)
        if (response) {
          if (response.taxInformation) {
            this.form = response.taxInformation
          }
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    deleteAccents (str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },
    checkUploadRequired () {
      this.uploadRequired = Boolean(
        this.form.certificateFile ||
        this.form.privateKeyFile ||
        this.form.privateKeyPassword
      )
    }
  }
}
</script>
